(() => {
  'use strict';
  const source = document.getElementById('JBFirstProductLabels');
  if (!source) return;
  const labels = JSON.parse(source.textContent).controls;
  if (!labels) return;
  const text = (node, value) => {
    if (!node || !value) return;
    if (node.matches('legend,.form__label') && node.children.length) {
      const label = [...node.childNodes].find(child => child.nodeType === Node.TEXT_NODE && child.textContent.trim());
      if (label) { if (label.textContent.trim() !== value) label.textContent = value; }
      else {
        let span = node.querySelector(':scope > .jb-controls-label-text');
        if (!span) { span = document.createElement('span'); span.className = 'jb-controls-label-text'; node.prepend(span); }
        if (span.textContent !== value) span.textContent = value;
      }
      return;
    }
    if (node.textContent !== value) node.textContent = value;
  };
  const columns = count => Math.min(3, Math.max(1, count));
  const originBridges = new WeakSet();
  const caption = (value, kind) => {
    const key = String(value).trim().toLowerCase();
    if (key === 'all natural' || key === 'natural') return labels.natural;
    if (key === 'all lab-grown' || key === 'lab-grown') return labels.lab;
    if (kind === 'model' && (key === 'original' || key === 'classic')) return labels.classic;
    if (key === 'half eternity') return labels.halfEternity;
    if (key === 'full eternity') return labels.fullEternity;
    if (key === 'round brilliant') return labels.roundBrilliant;
    return value;
  };
  function refine(info) {
    const root = info.closest('.jb-product-experience');
    if (!root) return;
    info.classList.add('jb-product-controls-final');
    let colored = false;
    const manifest = root.querySelector('script[data-jb-ring-catalog-manifest]') || document.querySelector('script[data-jb-ring-catalog-manifest]');
    if (manifest) {
      try {
        const config = JSON.parse(manifest.textContent).configuration;
        colored = config.records.some(record => Object.entries(record.specs || {}).some(([key,value]) => !/shape|cut/i.test(key) && /\b(ruby|rubies|sapphire|emerald|aquamarine|amethyst|topaz|garnet|tourmaline)\b/i.test(String(value))));
      } catch {}
    }
    const title = root.querySelector('h1')?.textContent || '';
    colored ||= /\b(ruby|rubies|sapphire|aquamarine|amethyst|topaz|garnet|tourmaline)\b/i.test(title) || (/emerald/i.test(title) && !/diamond|cut/i.test(title));
    info.querySelectorAll('fieldset[data-handle="metal"] .form__label, .jb-metal-swatches > .form__label').forEach(label => {
      const value = label.querySelector('.form__label__value');
      if (!value) return;
      let name = label.querySelector('.jb-controls-material-label');
      if (!name) {
        name = document.createElement('span'); name.className = 'jb-controls-material-label';
        [...label.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
        label.prepend(name);
      }
      text(name, labels.metal);
      text(value, value.textContent.replace(/\b(white|yellow|rose) gold\b/gi, match => match.replace(/\b\w/g, letter => letter.toUpperCase())));
      label.classList.add('jb-controls-material');
    });
    info.querySelectorAll('jb-stone-origin .form__label, fieldset[data-handle="diamond-origin"] .form__label').forEach(label => text(label, colored ? labels.gemstoneOrigin : labels.diamondOrigin));
    info.querySelectorAll('.jb-stone-origin__note').forEach(note => {
      if (!/Akoya|cultured/i.test(note.textContent)) text(note, colored ? labels.gemstoneScope : labels.diamondScope);
    });
    info.querySelectorAll('.jb-catalog-axis').forEach(field => {
      const key = field.dataset.jbAxisField;
      const buttons = [...field.querySelectorAll('button[data-jb-axis]')];
      field.classList.toggle('jb-controls-single-option',buttons.length === 1 && !field.classList.contains('jb-stone-option-field'));
      let label = null;
      if (key === 'bandVersion' || key === 'version') label = labels.model;
      else if (key === 'diamondType' || key === 'shape') label = labels.shape;
      else if (/^(carat|caratWeight|carat_weight)$/.test(key)) label = labels.caratWeight;
      else if (key === 'sideStoneShape') label = labels.sideStoneShape;
      else if (key === 'bandStyle' && buttons.length && buttons.every(button => /^(half|full)(?:[-\s]eternity)?$/i.test(button.dataset.jbValue))) label = labels.coverage;
      if (label) text(field.querySelector('legend'), label);
    });
    info.querySelectorAll('fieldset[data-handle="version"] > .form__label').forEach(label => text(label, labels.model));
    info.querySelectorAll('fieldset[data-handle="shape"] > .form__label').forEach(label => text(label, labels.shape));
    const origin = info.querySelector('jb-stone-origin select[data-jb-stone-origin]');
    const nativeOrigin = info.querySelector('fieldset[data-handle="diamond-origin"] select');
    if (origin && nativeOrigin && [...origin.options].filter(option => option.value).every(option => [...nativeOrigin.options].some(native => native.value === option.value))) {
      nativeOrigin.closest('fieldset').classList.add('jb-controls-origin-source');
      if (!originBridges.has(origin)) {
        originBridges.add(origin);
        origin.addEventListener('change',()=>{
          if (!origin.value || nativeOrigin.value === origin.value) return;
          nativeOrigin.value = origin.value;
          nativeOrigin.dispatchEvent(new Event('input',{bubbles:true}));
          nativeOrigin.dispatchEvent(new Event('change',{bubbles:true}));
        });
      }
    }
    info.querySelectorAll('.jb-first-origin-buttons, .jb-five-stone-version-buttons, .jb-wrapped-shape-buttons, .jb-catalog-axis__buttons').forEach(group => {
      const buttons = [...group.querySelectorAll(':scope > button')];
      const count = String(columns(buttons.length));
      if (group.style.getPropertyValue('--jb-control-columns') !== count) group.style.setProperty('--jb-control-columns', count);
      group.classList.toggle('jb-controls-paired', buttons.some(button => button.querySelectorAll('img').length > 1));
      const field = group.closest('fieldset');
      const model = group.classList.contains('jb-five-stone-version-buttons') || /^(bandVersion|version)$/.test(field?.dataset.jbAxisField || '');
      if (model) {
        const order = { petite:0, original:1, classic:1, large:2 };
        const sorted = [...buttons].sort((a,b) => (order[(a.dataset.jbValue || a.dataset.optionValue || '').toLowerCase()] ?? 3) - (order[(b.dataset.jbValue || b.dataset.optionValue || '').toLowerCase()] ?? 3));
        sorted.forEach((button,index) => { if (group.children[index] !== button) group.insertBefore(button,group.children[index] || null); });
      }
      buttons.forEach(button => {
        const span = [...button.children].find(child => child.tagName === 'SPAN' && !child.classList.contains('jb-shape-images'));
        if (span) text(span, caption(span.textContent, model ? 'model' : ''));
      });
      if (group.hasAttribute('aria-label')) {
        const name = field?.querySelector('.form__label')?.textContent || group.closest('jb-stone-origin')?.querySelector('.form__label')?.textContent;
        if (name && group.getAttribute('aria-label') !== name) group.setAttribute('aria-label',name);
      }
    });
    info.querySelectorAll('fieldset.product-form__input--block').forEach(field => {
      if (field.dataset.handle === 'metal' || field.querySelector('.jb-metal-swatches__choice')) { field.classList.remove('jb-controls-native-grid'); return; }
      if (field.querySelector('select')) return;
      const inputs = [...field.querySelectorAll('input[type="radio"]')];
      if (!inputs.length) return;
      field.classList.add('jb-controls-native-grid');
      const count = String(columns(inputs.length));
      if (field.style.getPropertyValue('--jb-control-columns') !== count) field.style.setProperty('--jb-control-columns',count);
      field.querySelectorAll('label[for]').forEach(label => {
        const span = label.querySelector('span:not(.jb-shape-images)');
        if (span) text(span,caption(span.textContent,field.dataset.handle === 'version' ? 'model' : ''));
      });
    });
    info.querySelectorAll('.jb-request-price-button').forEach(button => {
      const node = button.querySelector('.jb-motion__label') || button.querySelector('span') || button;
      text(node, labels.request);
    });
  }
  let queued = false;
  const run = () => { queued = false; document.querySelectorAll('.jb-product-experience .product-information--inner').forEach(refine); };
  const schedule = () => { if (!queued) { queued = true; queueMicrotask(run); } };
  const start = () => {
    run();
    document.querySelectorAll('.jb-product-experience .product-information--inner').forEach(info => {
      new MutationObserver(schedule).observe(info, { childList: true, characterData: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
  document.addEventListener('product:variant-change',schedule);
})();


